// extracted by mini-css-extract-plugin
export var gif = "_mh-0";